var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-3 pa-0"},[_c('v-flex',[_c('RmaDetails',{attrs:{"rma":_vm.rma}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }